module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/main-categories-icons/26-1f6dab1e2ca8a4f83c8cd146cec7a0e0.svg";